import useJwt from './useJwt';
import axios from '@/libs/axios';

const { jwt } = useJwt(axios, {});
export default jwt;
